import { render, staticRenderFns } from "./SubscriptionPending.vue?vue&type=template&id=799a807e&scoped=true&"
import script from "./SubscriptionPending.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPending.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionPending.vue?vue&type=style&index=0&id=799a807e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799a807e",
  null
  
)

export default component.exports